export const DAISYCON_UTM_SOURCE = 'daisycon';

export const NESTPICK_UTM_SOURCE = 'nestpick.com';

export const NESTPICK_API_BASE_URL = 'https://partners.nestpick.com';
